<template>
  <div class="flex flex-col w-96">
    <div class="bg-neutral-secondary rounded-md px-4 py-3 mb-2">
      <div class="grid grid-flow-row grid-cols-3">
        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('common.amount') }}
        </NText>

        <div class="flex justify-end items-center pb-3 col-span-2">
          <NumberFormatter #="{ number }" :value="item.depositValue">
            <NText variant="caption1" weight="medium">
              {{ number }}
              <NText
                variant="caption1"
                class="text-neutral-secondary text-left align-middle"
              >
                {{ t('misc.rial') }}
              </NText>
            </NText>
          </NumberFormatter>
        </div>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('common.date') }} {{ t('common.submit_request') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pb-3 col-span-2"
        >
          {{ requestDate }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press border-b border-neutral-secondary self-center pb-3 col-span-1"
        >
          {{ t('common.requestStatus') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-centertext-neutral-secondary-press border-b border-neutral-secondary pb-3 col-span-2"
        >
          {{ item.requestState }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press py-3 self-center col-span-1"
        >
          {{ t('deposit.depositReceiptDate') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press py-3 col-span-2"
        >
          {{ depositedDate }}
        </NText>

        <NText
          variant="caption1"
          weight="bold"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('modules.cash.register_deposit_receipt.broker_account_number') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pb-3 col-span-2"
        >
          {{ item.sourceAccount }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press border-b border-neutral-secondary self-center pb-3 col-span-1"
        >
          {{ t('deposit.receiptNumber') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press border-b border-neutral-secondary pb-3 col-span-2"
        >
          {{ item.trackingNumber }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pt-3 self-center col-span-1"
        >
          {{ t('deposit.requestCode') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pt-3 col-span-2"
        >
          {{ item.requestSerialNumber }}
        </NText>
      </div>
    </div>

    <NButton
      variant="fill"
      color="gray"
      class="w-full"
      :loading="isLoadingAttachment"
      :disabled="isLoadingAttachment"
      @click="download(item.depositAttachmentId, link)"
    >
      <NText
        variant="caption1"
        weight="bold"
        class="text-neutral-secondary-hover"
      >
        {{ t('deposit.showReceipt') }}
      </NText>
    </NButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useGetReceiptAttachmentQuery } from '@core/cash';
import { Deposit } from '@libs/api-reference';
import { download } from '@libs/utils';

import NumberFormatter from '@/components/Number.vue';

type DepositReceiptItemDialogPropsType = {
  item: Deposit;
};

const props = defineProps<DepositReceiptItemDialogPropsType>();

const { attachment, isLoadingAttachment } = useGetReceiptAttachmentQuery(
  props.item.depositAttachmentId
);

const { t, d } = useI18n();

const link = computed(() => `data:image/png;base64,${attachment.value}`);

const requestDate = computed(() =>
  props.item.requestEntryDate
    ? `${d(props.item.requestEntryDate, 'shortTime')} , ${d(
        props.item.requestEntryDate,
        'shortDate'
      )}`
    : ' '
);

const depositedDate = computed(() =>
  props.item.depositedDate ? `${d(props.item.depositedDate, 'shortDate')}` : ' '
);
</script>
